<template>
<div>

  <div class="loader"></div>
  <div class="fundo-loader"> </div>

</div>
</template>

<script>

  export default {

    data(){
      return{
      }
    },

    methods: {
    },

  }

</script>


<style scoped>

  .loader {
      position: absolute;
      z-index: 999;
      left:50%;
      top:50%;
      margin-left:-25px;
      /*margin-top:-10px; */
      border: 5px solid orange; /* Light grey */
      border-top: 5px solid cornsilk; /* Blue */
      border-radius: 0%;
      width: 40px;
      height: 40px;
      animation: spin 2s linear infinite;
  }

  @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
  }

  .fundo-loader{
    border: solid ;
    position: fixed;
    top: 0; right: 0; bottom: 0; left: 0;
    background-color: #000000;
    z-index: 20;
    opacity: 80%;
  }

</style>


// WEBPACK FOOTER //
// src/components/cc_geral/cc_loading.vue